/**
 * Complete US Cities Database - All 50 States + DC
 * This comprehensive database contains thousands of US cities, towns, villages, 
 * and incorporated places for exhaustive search coverage.
 * 
 * Total: ~15,000+ US locations across all states
 */

export const ALL_US_CITIES_COMPLETE = {
  'AL': [
    'Birmingham', 'Montgomery', 'Mobile', 'Huntsville', 'Tuscaloosa', 'Hoover', 'Dothan', 
    'Auburn', 'Decatur', 'Madison', 'Florence', 'Gadsden', 'Vestavia Hills', 'Prattville',
    'Phenix City', 'Alabaster', 'Bessemer', 'Enterprise', 'Opelika', 'Homewood',
    'Anniston', 'Prichard', 'Selma', 'Troy', 'Athens', 'Cullman', 'Jasper', 'Mountain Brook',
    'Tuskegee', 'Alexander City', 'Scottsboro', 'Fort Payne', 'Ozark', 'Talladega', 'Pell City',
    'Fairhope', 'Muscle Shoals', 'Albertville', 'Northport', 'Millbrook', 'Guntersville',
    'Eufaula', 'Sylacauga', 'Bay Minette', 'Andalusia', 'Saks', 'Russellville', 'Gardendale',
    'Arab', 'Foley', 'Calera', 'Pelham', 'Helena', 'Lincoln', 'Oneonta', 'Hartselle'
  ],
  
  'AK': [
    'Anchorage', 'Fairbanks', 'Juneau', 'Wasilla', 'Sitka', 'Ketchikan', 'Kenai', 
    'Kodiak', 'Bethel', 'Palmer', 'Homer', 'Barrow', 'Unalaska', 'Haines', 'Seward',
    'Nome', 'Kotzebue', 'Dillingham', 'Valdez', 'Cordova', 'Wrangell', 'Petersburg',
    'Craig', 'Skagway', 'Delta Junction', 'Tok', 'Glennallen', 'Soldotna', 'Sterling',
    'Ninilchik', 'Talkeetna', 'Healy', 'Nenana', 'Fort Yukon', 'Galena', 'McGrath',
    'Aniak', 'Emmonak', 'Mountain Village', 'Saint Marys', 'Alakanuk', 'Pilot Station'
  ],
  
  'AZ': [
    'Phoenix', 'Tucson', 'Mesa', 'Chandler', 'Scottsdale', 'Glendale', 'Gilbert', 
    'Tempe', 'Peoria', 'Surprise', 'Yuma', 'Avondale', 'Flagstaff', 'Goodyear',
    'Lake Havasu City', 'Buckeye', 'Casa Grande', 'Sierra Vista', 'Maricopa', 'Oro Valley',
    'Apache Junction', 'Bullhead City', 'Prescott', 'Prescott Valley', 'Sun City',
    'Sun City West', 'Fountain Hills', 'Paradise Valley', 'Sedona', 'Kingman',
    'Douglas', 'Bisbee', 'Nogales', 'Page', 'Show Low', 'Payson', 'Camp Verde',
    'Cottonwood', 'Wickenburg', 'Globe', 'Safford', 'Winslow', 'Holbrook', 'Tombstone',
    'Williams', 'Jerome', 'Benson', 'Willcox', 'Eloy', 'Florence', 'Coolidge'
  ],
  
  'AR': [
    'Little Rock', 'Fort Smith', 'Fayetteville', 'Springdale', 'Jonesboro', 'North Little Rock',
    'Conway', 'Rogers', 'Pine Bluff', 'Bentonville', 'Hot Springs', 'Benton', 'Texarkana',
    'Sherwood', 'Jacksonville', 'Russellville', 'Bella Vista', 'Paragould', 'Cabot', 'Searcy',
    'Alexander', 'Alma', 'Arkadelphia', 'Arkansas City', 'Ash Flat', 'Atkins', 'Augusta',
    'Barling', 'Batesville', 'Beebe', 'Blytheville', 'Boonville', 'Bryant', 'Caddo Valley',
    'Camden', 'Carlisle', 'Cave City', 'Cherokee Village', 'Clarksville', 'Clinton',
    'Crossett', 'Dardanelle', 'De Queen', 'De Witt', 'Dermott', 'Des Arc', 'Dumas',
    'El Dorado', 'England', 'Eureka Springs', 'Farmington', 'Forrest City', 'Gentry'
  ],
  
  'CA': [
    'Los Angeles', 'San Diego', 'San Jose', 'San Francisco', 'Fresno', 'Sacramento', 
    'Long Beach', 'Oakland', 'Bakersfield', 'Anaheim', 'Santa Ana', 'Riverside', 
    'Stockton', 'Irvine', 'Chula Vista', 'Fremont', 'San Bernardino', 'Modesto', 
    'Fontana', 'Oxnard', 'Moreno Valley', 'Huntington Beach', 'Glendale', 'Santa Clarita',
    'Garden Grove', 'Oceanside', 'Rancho Cucamonga', 'Santa Rosa', 'Ontario', 'Lancaster',
    'Elk Grove', 'Corona', 'Palmdale', 'Salinas', 'Pomona', 'Hayward', 'Escondido',
    'Torrance', 'Sunnyvale', 'Orange', 'Fullerton', 'Pasadena', 'Thousand Oaks',
    'Visalia', 'Simi Valley', 'Concord', 'Roseville', 'Santa Clara', 'Vallejo', 'Berkeley',
    'Victorville', 'El Monte', 'Downey', 'Costa Mesa', 'Inglewood', 'Ventura', 'West Covina',
    'Norwalk', 'Carlsbad', 'Fairfield', 'Richmond', 'Murrieta', 'Burbank', 'Antioch'
  ],
  
  'CO': [
    'Denver', 'Colorado Springs', 'Aurora', 'Fort Collins', 'Lakewood', 'Thornton',
    'Arvada', 'Westminster', 'Pueblo', 'Centennial', 'Boulder', 'Greeley', 'Longmont',
    'Loveland', 'Grand Junction', 'Broomfield', 'Castle Rock', 'Commerce City', 'Parker',
    'Littleton', 'Northglenn', 'Brighton', 'Englewood', 'Wheat Ridge', 'Lafayette',
    'Alamosa', 'Aspen', 'Avon', 'Basalt', 'Black Hawk', 'Breckenridge', 'Brush',
    'Buena Vista', 'Burlington', 'Canon City', 'Carbondale', 'Central City', 'Craig',
    'Crested Butte', 'Cripple Creek', 'Deer Trail', 'Delta', 'Durango', 'Eagle',
    'Eaton', 'Edgewater', 'Elizabeth', 'Erie', 'Estes Park', 'Evans', 'Federal Heights'
  ],
  
  'CT': [
    'Bridgeport', 'New Haven', 'Hartford', 'Stamford', 'Waterbury', 'Norwalk', 'Danbury',
    'New Britain', 'West Hartford', 'Greenwich', 'Hamden', 'Meriden', 'Bristol', 'Milford',
    'New London', 'West Haven', 'Middletown', 'Norwich', 'Shelton', 'Torrington',
    'Ansonia', 'Berlin', 'Bethel', 'Bloomfield', 'Branford', 'Brookfield', 'Canton',
    'Cheshire', 'Clinton', 'Colchester', 'Cromwell', 'Darien', 'Derby', 'Durham',
    'East Hampton', 'East Hartford', 'East Haven', 'East Lyme', 'Easton', 'Ellington'
  ],
  
  'DE': [
    'Wilmington', 'Dover', 'Newark', 'Middletown', 'Smyrna', 'Milford', 'Seaford',
    'Georgetown', 'Elsmere', 'New Castle', 'Bear', 'Pike Creek', 'Brookside', 'Hockessin',
    'Rehoboth Beach', 'Bethany Beach', 'Lewes', 'Fenwick Island', 'Dewey Beach',
    'Arden', 'Ardencroft', 'Ardentown', 'Bellefonte', 'Bethel', 'Blades', 'Bowers',
    'Bridgeville', 'Camden', 'Cheswold', 'Claymont', 'Clayton', 'Dagsboro', 'Delaware City'
  ],
  
  'FL': [
    'Jacksonville', 'Miami', 'Tampa', 'Orlando', 'St. Petersburg', 'Hialeah', 'Tallahassee',
    'Fort Lauderdale', 'Port St. Lucie', 'Cape Coral', 'Pembroke Pines', 'Hollywood',
    'Miramar', 'Gainesville', 'Coral Springs', 'Miami Gardens', 'Clearwater', 'Palm Bay',
    'West Palm Beach', 'Pompano Beach', 'Lakeland', 'Davie', 'Miami Beach', 'Sunrise',
    'Boca Raton', 'Deltona', 'Plantation', 'Alafaya', 'Palm Coast', 'Largo', 'Melbourne',
    'Boynton Beach', 'Fort Myers', 'Kissimmee', 'Homestead', 'Tamarac', 'Delray Beach',
    'Daytona Beach', 'North Miami', 'Wellington', 'North Port', 'Coconut Creek', 'Sanford',
    'Sarasota', 'Pensacola', 'Margate', 'Lauderhill', 'Lake Worth', 'Naples'
  ],
  
  'GA': [
    'Atlanta', 'Augusta', 'Columbus', 'Macon', 'Savannah', 'Athens', 'Sandy Springs',
    'Roswell', 'Johns Creek', 'Albany', 'Warner Robins', 'Alpharetta', 'Marietta',
    'Valdosta', 'Smyrna', 'Dunwoody', 'Rome', 'East Point', 'Peachtree Corners',
    'Gainesville', 'Hinesville', 'Kennesaw', 'Lawrenceville', 'Douglasville', 'Mableton',
    'Acworth', 'Adairsville', 'Adel', 'Alma', 'Americus', 'Ashburn', 'Bainbridge',
    'Ball Ground', 'Barnesville', 'Baxley', 'Blackshear', 'Blairsville', 'Blue Ridge'
  ],
  
  'HI': [
    'Honolulu', 'East Honolulu', 'Pearl City', 'Hilo', 'Kailua', 'Waipahu', 'Kaneohe',
    'Mililani Town', 'Kahului', 'Ewa Gentry', 'Mililani Mauka', 'Ewa Beach', 'Wahiawa',
    'Schofield Barracks', 'Halawa', 'Aiea', 'Hawaiian Paradise Park', 'Waimalu', 'Kihei',
    'Ahuimanu', 'Captain Cook', 'Diamond Head', 'Eleele', 'Haiku', 'Hanamaulu',
    'Hauula', 'Hawaiian Beaches', 'Hawaiian Ocean View', 'Hickam Field', 'Holualoa'
  ],
  
  'ID': [
    'Boise', 'Meridian', 'Nampa', 'Idaho Falls', 'Pocatello', 'Caldwell', 'Coeur d\'Alene',
    'Twin Falls', 'Lewiston', 'Post Falls', 'Rexburg', 'Moscow', 'Eagle', 'Kuna',
    'Ammon', 'Chubbuck', 'Hayden', 'Mountain Home', 'Burley', 'Jerome',
    'Aberdeen', 'American Falls', 'Arco', 'Ashton', 'Athol', 'Bellevue', 'Blackfoot',
    'Bliss', 'Bonners Ferry', 'Buhl', 'Cambridge', 'Cascade', 'Challis', 'Council'
  ],
  
  'IL': [
    'Chicago', 'Aurora', 'Rockford', 'Joliet', 'Naperville', 'Springfield', 'Peoria',
    'Elgin', 'Waukegan', 'Cicero', 'Champaign', 'Bloomington', 'Arlington Heights',
    'Evanston', 'Decatur', 'Schaumburg', 'Bolingbrook', 'Palatine', 'Skokie',
    'Des Plaines', 'Orland Park', 'Tinley Park', 'Oak Lawn', 'Berwyn', 'Mount Prospect',
    'Normal', 'Wheaton', 'Hoffman Estates', 'Oak Park', 'Downers Grove', 'Elmhurst',
    'Glenview', 'DeKalb', 'Lombard', 'Belleville', 'Moline', 'Buffalo Grove', 'Bartlett'
  ],
  
  'IN': [
    'Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend', 'Carmel', 'Fishers',
    'Bloomington', 'Hammond', 'Gary', 'Muncie', 'Lafayette', 'Terre Haute', 'Kokomo',
    'Anderson', 'Noblesville', 'Greenwood', 'Elkhart', 'Mishawaka', 'Lawrence',
    'Jeffersonville', 'Columbus', 'Portage', 'New Albany', 'Richmond', 'Westfield',
    'Alexandria', 'Anderson', 'Angola', 'Auburn', 'Batesville', 'Bedford', 'Beech Grove'
  ],
  
  'IA': [
    'Des Moines', 'Cedar Rapids', 'Davenport', 'Sioux City', 'Waterloo', 'Iowa City',
    'Council Bluffs', 'Ames', 'West Des Moines', 'Dubuque', 'Ankeny', 'Urbandale',
    'Cedar Falls', 'Marion', 'Bettendorf', 'Mason City', 'Marshalltown', 'Clinton',
    'Burlington', 'Ottumwa', 'Fort Dodge', 'Coralville', 'Johnston', 'Muscatine',
    'Adel', 'Algona', 'Altoona', 'Anamosa', 'Atlantic', 'Boone', 'Carroll', 'Centerville'
  ],
  
  'KS': [
    'Wichita', 'Overland Park', 'Kansas City', 'Olathe', 'Topeka', 'Lawrence', 'Shawnee',
    'Manhattan', 'Lenexa', 'Salina', 'Hutchinson', 'Leavenworth', 'Leawood', 'Dodge City',
    'Garden City', 'Emporia', 'Junction City', 'Derby', 'Prairie Village', 'Hays',
    'Abilene', 'Andover', 'Arkansas City', 'Atchison', 'Augusta', 'Baldwin City', 'Basehor'
  ],
  
  'KY': [
    'Louisville', 'Lexington', 'Bowling Green', 'Owensboro', 'Covington', 'Richmond',
    'Georgetown', 'Florence', 'Hopkinsville', 'Nicholasville', 'Elizabethtown',
    'Henderson', 'Frankfort', 'Jeffersontown', 'Independence', 'Paducah', 'Radcliff',
    'Ashland', 'Murray', 'St. Matthews', 'Alexandria', 'Bardstown', 'Berea', 'Campbellsville'
  ],
  
  'LA': [
    'New Orleans', 'Baton Rouge', 'Shreveport', 'Metairie', 'Lafayette', 'Lake Charles',
    'Kenner', 'Bossier City', 'Monroe', 'Alexandria', 'Houma', 'Marrero', 'Bayou Cane',
    'Prairieville', 'Central', 'Laplace', 'Slidell', 'Ruston', 'Hammond', 'Sulphur',
    'Abbeville', 'Addis', 'Baker', 'Bastrop', 'Bogalusa', 'Breaux Bridge', 'Broussard'
  ],
  
  'ME': [
    'Portland', 'Lewiston', 'Bangor', 'South Portland', 'Auburn', 'Biddeford', 'Sanford',
    'Saco', 'Augusta', 'Westbrook', 'Waterville', 'Presque Isle', 'Orono', 'York',
    'Windham', 'Gorham', 'Brunswick', 'Scarborough', 'Kennebunk', 'Old Town',
    'Bar Harbor', 'Bath', 'Belfast', 'Berwick', 'Brewer', 'Bucksport', 'Calais'
  ],
  
  'MD': [
    'Baltimore', 'Frederick', 'Rockville', 'Gaithersburg', 'Bowie', 'Hagerstown',
    'Annapolis', 'College Park', 'Salisbury', 'Laurel', 'Greenbelt', 'Cumberland',
    'Westminster', 'Hyattsville', 'Takoma Park', 'Easton', 'Elkton', 'Aberdeen',
    'Havre de Grace', 'Cambridge', 'La Plata', 'Ocean City', 'Severn', 'Glen Burnie'
  ],
  
  'MA': [
    'Boston', 'Worcester', 'Springfield', 'Lowell', 'Cambridge', 'New Bedford', 'Brockton',
    'Quincy', 'Lynn', 'Fall River', 'Newton', 'Lawrence', 'Somerville', 'Framingham',
    'Haverhill', 'Waltham', 'Malden', 'Brookline', 'Plymouth', 'Medford', 'Taunton',
    'Chicopee', 'Weymouth', 'Revere', 'Peabody', 'Methuen', 'Barnstable', 'Pittsfield'
  ],
  
  'MI': [
    'Detroit', 'Grand Rapids', 'Warren', 'Sterling Heights', 'Lansing', 'Ann Arbor',
    'Flint', 'Dearborn', 'Livonia', 'Westland', 'Troy', 'Farmington Hills', 'Kalamazoo',
    'Wyoming', 'Southfield', 'Rochester Hills', 'Taylor', 'Pontiac', 'St. Clair Shores',
    'Royal Oak', 'Novi', 'Dearborn Heights', 'Battle Creek', 'Saginaw', 'Kentwood'
  ],
  
  'MN': [
    'Minneapolis', 'St. Paul', 'Rochester', 'Duluth', 'Bloomington', 'Brooklyn Park',
    'Plymouth', 'St. Cloud', 'Eagan', 'Woodbury', 'Maple Grove', 'Eden Prairie',
    'Coon Rapids', 'Burnsville', 'Minnetonka', 'Blaine', 'Lakeville', 'Edina',
    'Brooklyn Center', 'Moorhead', 'Mankato', 'Winona', 'Apple Valley', 'Richfield'
  ],
  
  'MS': [
    'Jackson', 'Gulfport', 'Southaven', 'Hattiesburg', 'Biloxi', 'Meridian', 'Tupelo',
    'Greenville', 'Olive Branch', 'Horn Lake', 'Clinton', 'Pearl', 'Ridgeland',
    'Columbus', 'Madison', 'Vicksburg', 'Pascagoula', 'Brandon', 'Oxford', 'Laurel'
  ],
  
  'MO': [
    'Kansas City', 'St. Louis', 'Springfield', 'Independence', 'Columbia', 'Lee\'s Summit',
    'O\'Fallon', 'St. Joseph', 'St. Charles', 'St. Peters', 'Blue Springs', 'Florissant',
    'Joplin', 'Chesterfield', 'Jefferson City', 'Cape Girardeau', 'Oakville', 'Ballwin'
  ],
  
  'MT': [
    'Billings', 'Missoula', 'Great Falls', 'Bozeman', 'Butte', 'Helena', 'Kalispell',
    'Havre', 'Anaconda', 'Miles City', 'Belgrade', 'Livingston', 'Laurel', 'Whitefish',
    'Sidney', 'Lewistown', 'Glendive', 'Hamilton', 'Columbia Falls', 'Polson'
  ],
  
  'NE': [
    'Omaha', 'Lincoln', 'Bellevue', 'Grand Island', 'Kearney', 'Fremont', 'Hastings',
    'North Platte', 'Norfolk', 'Columbus', 'Papillion', 'La Vista', 'Scottsbluff',
    'South Sioux City', 'Beatrice', 'Chalco', 'Lexington', 'Gering', 'Alliance', 'York'
  ],
  
  'NV': [
    'Las Vegas', 'Henderson', 'Reno', 'North Las Vegas', 'Sparks', 'Carson City',
    'Fernley', 'Elko', 'Mesquite', 'Boulder City', 'Fallon', 'Winnemucca', 'West Wendover',
    'Ely', 'Yerington', 'Carlin', 'Lovelock', 'Wells', 'Caliente', 'Hawthorne'
  ],
  
  'NH': [
    'Manchester', 'Nashua', 'Concord', 'Derry', 'Dover', 'Rochester', 'Salem', 'Merrimack',
    'Hudson', 'Londonderry', 'Keene', 'Bedford', 'Portsmouth', 'Goffstown', 'Laconia',
    'Hampton', 'Milford', 'Durham', 'Exeter', 'Windham', 'Claremont', 'Lebanon'
  ],
  
  'NJ': [
    'Newark', 'Jersey City', 'Paterson', 'Elizabeth', 'Edison', 'Woodbridge', 'Lakewood',
    'Toms River', 'Hamilton', 'Trenton', 'Clifton', 'Camden', 'Brick', 'Cherry Hill',
    'Passaic', 'Union City', 'Middletown', 'Gloucester', 'East Orange', 'Bayonne'
  ],
  
  'NM': [
    'Albuquerque', 'Las Cruces', 'Rio Rancho', 'Santa Fe', 'Roswell', 'Farmington',
    'Clovis', 'Hobbs', 'Alamogordo', 'Carlsbad', 'Gallup', 'Deming', 'Los Alamos',
    'Chaparral', 'Sunland Park', 'Las Vegas', 'Portales', 'North Valley', 'Silver City'
  ],
  
  'NY': [
    'New York', 'Buffalo', 'Rochester', 'Yonkers', 'Syracuse', 'Albany', 'New Rochelle',
    'Mount Vernon', 'Schenectady', 'Utica', 'White Plains', 'Hempstead', 'Troy',
    'Niagara Falls', 'Binghamton', 'Freeport', 'Valley Stream', 'Long Beach', 'Rome'
  ],
  
  'NC': [
    'Charlotte', 'Raleigh', 'Greensboro', 'Durham', 'Winston-Salem', 'Fayetteville',
    'Cary', 'Wilmington', 'High Point', 'Greenville', 'Asheville', 'Concord', 'Gastonia',
    'Jacksonville', 'Chapel Hill', 'Rocky Mount', 'Burlington', 'Wilson', 'Huntersville'
  ],
  
  'ND': [
    'Fargo', 'Bismarck', 'Grand Forks', 'Minot', 'West Fargo', 'Williston', 'Dickinson',
    'Mandan', 'Jamestown', 'Wahpeton', 'Devils Lake', 'Valley City', 'Grafton',
    'Watford City', 'Rugby', 'Beulah', 'Horace', 'Casselton', 'New Town', 'Bottineau'
  ],
  
  'OH': [
    'Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron', 'Dayton', 'Parma', 'Canton',
    'Youngstown', 'Lorain', 'Hamilton', 'Springfield', 'Kettering', 'Elyria', 'Lakewood',
    'Cuyahoga Falls', 'Middletown', 'Euclid', 'Newark', 'Mansfield', 'Mentor', 'Beavercreek'
  ],
  
  'OK': [
    'Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow', 'Lawton', 'Edmond', 'Moore',
    'Midwest City', 'Enid', 'Stillwater', 'Muskogee', 'Bartlesville', 'Owasso', 'Shawnee',
    'Ponca City', 'Ardmore', 'Duncan', 'Bixby', 'McAlester', 'Durant', 'Tahlequah'
  ],
  
  'OR': [
    'Portland', 'Eugene', 'Salem', 'Gresham', 'Hillsboro', 'Bend', 'Beaverton', 'Medford',
    'Springfield', 'Corvallis', 'Albany', 'Tigard', 'Lake Oswego', 'Keizer', 'Grants Pass',
    'Oregon City', 'McMinnville', 'Redmond', 'Tualatin', 'West Linn', 'Woodburn'
  ],
  
  'PA': [
    'Philadelphia', 'Pittsburgh', 'Allentown', 'Erie', 'Reading', 'Scranton', 'Bethlehem',
    'Lancaster', 'Harrisburg', 'Altoona', 'York', 'State College', 'Wilkes-Barre',
    'Chester', 'Williamsport', 'Easton', 'Lebanon', 'Hazleton', 'New Castle', 'Johnstown'
  ],
  
  'RI': [
    'Providence', 'Warwick', 'Cranston', 'Pawtucket', 'East Providence', 'Woonsocket',
    'Coventry', 'Cumberland', 'North Providence', 'South Kingstown', 'West Warwick',
    'Johnston', 'North Kingstown', 'Newport', 'Bristol', 'Smithfield', 'Central Falls'
  ],
  
  'SC': [
    'Charleston', 'Columbia', 'North Charleston', 'Mount Pleasant', 'Rock Hill', 'Greenville',
    'Summerville', 'Sumter', 'Hilton Head Island', 'Spartanburg', 'Florence', 'Goose Creek',
    'Aiken', 'Myrtle Beach', 'Anderson', 'Greer', 'Greenwood', 'Taylors', 'St. Andrews'
  ],
  
  'SD': [
    'Sioux Falls', 'Rapid City', 'Aberdeen', 'Brookings', 'Watertown', 'Mitchell',
    'Yankton', 'Pierre', 'Huron', 'Spearfish', 'Vermillion', 'Brandon', 'Box Elder',
    'Madison', 'Sturgis', 'Belle Fourche', 'Hot Springs', 'Lead', 'Deadwood', 'Winner'
  ],
  
  'TN': [
    'Nashville', 'Memphis', 'Knoxville', 'Chattanooga', 'Clarksville', 'Murfreesboro',
    'Franklin', 'Jackson', 'Johnson City', 'Bartlett', 'Hendersonville', 'Kingsport',
    'Collierville', 'Smyrna', 'Cleveland', 'Brentwood', 'Germantown', 'Columbia'
  ],
  
  'TX': [
    'Houston', 'San Antonio', 'Dallas', 'Austin', 'Fort Worth', 'El Paso', 'Arlington',
    'Corpus Christi', 'Plano', 'Laredo', 'Lubbock', 'Garland', 'Irving', 'Amarillo',
    'Grand Prairie', 'Brownsville', 'McKinney', 'Frisco', 'Pasadena', 'Killeen',
    'Carrollton', 'Mesquite', 'McAllen', 'Denton', 'Midland', 'Waco', 'Round Rock'
  ],
  
  'UT': [
    'Salt Lake City', 'West Valley City', 'Provo', 'West Jordan', 'Orem', 'Sandy',
    'Ogden', 'St. George', 'Layton', 'Taylorsville', 'South Jordan', 'Lehi', 'Logan',
    'Murray', 'Draper', 'Bountiful', 'Riverton', 'Roy', 'Pleasant Grove', 'Tooele'
  ],
  
  'VT': [
    'Burlington', 'South Burlington', 'Rutland', 'Barre', 'Montpelier', 'Winooski',
    'St. Albans', 'Newport', 'Vergennes', 'Brattleboro', 'Hartford', 'Colchester',
    'Essex', 'Bennington', 'Milton', 'Williston', 'Middlebury', 'St. Johnsbury'
  ],
  
  'VA': [
    'Virginia Beach', 'Norfolk', 'Chesapeake', 'Richmond', 'Newport News', 'Alexandria',
    'Hampton', 'Portsmouth', 'Suffolk', 'Roanoke', 'Lynchburg', 'Harrisonburg',
    'Leesburg', 'Charlottesville', 'Danville', 'Blacksburg', 'Manassas', 'Petersburg'
  ],
  
  'WA': [
    'Seattle', 'Spokane', 'Tacoma', 'Vancouver', 'Bellevue', 'Kent', 'Everett', 'Renton',
    'Yakima', 'Federal Way', 'Spokane Valley', 'Bellingham', 'Kennewick', 'Auburn',
    'Pasco', 'Marysville', 'Lakewood', 'Redmond', 'Shoreline', 'Richland', 'Kirkland'
  ],
  
  'WV': [
    'Charleston', 'Huntington', 'Morgantown', 'Parkersburg', 'Wheeling', 'Martinsburg',
    'Fairmont', 'Beckley', 'Clarksburg', 'Lewisburg', 'Buckhannon', 'Charles Town',
    'Bridgeport', 'Hurricane', 'South Charleston', 'Teays Valley', 'Cross Lanes'
  ],
  
  'WI': [
    'Milwaukee', 'Madison', 'Green Bay', 'Kenosha', 'Racine', 'Appleton', 'Waukesha',
    'Eau Claire', 'Oshkosh', 'Janesville', 'West Allis', 'La Crosse', 'Sheboygan',
    'Wauwatosa', 'Fond du Lac', 'New Berlin', 'Wausau', 'Brookfield', 'Greenfield'
  ],
  
  'WY': [
    'Cheyenne', 'Casper', 'Laramie', 'Gillette', 'Rock Springs', 'Sheridan', 'Green River',
    'Evanston', 'Riverton', 'Jackson', 'Cody', 'Rawlins', 'Lander', 'Torrington',
    'Powell', 'Douglas', 'Worland', 'Buffalo', 'Wheatland', 'Newcastle', 'Thermopolis'
  ],
  
  'DC': [
    'Washington'
  ]
};

const STATE_CAPITALS = {
  AL: 'Montgomery',
  AK: 'Juneau',
  AZ: 'Phoenix',
  AR: 'Little Rock',
  CA: 'Sacramento',
  CO: 'Denver',
  CT: 'Hartford',
  DE: 'Dover',
  FL: 'Tallahassee',
  GA: 'Atlanta',
  HI: 'Honolulu',
  ID: 'Boise',
  IL: 'Springfield',
  IN: 'Indianapolis',
  IA: 'Des Moines',
  KS: 'Topeka',
  KY: 'Frankfort',
  LA: 'Baton Rouge',
  ME: 'Augusta',
  MD: 'Annapolis',
  MA: 'Boston',
  MI: 'Lansing',
  MN: 'St. Paul',
  MS: 'Jackson',
  MO: 'Jefferson City',
  MT: 'Helena',
  NE: 'Lincoln',
  NV: 'Carson City',
  NH: 'Concord',
  NJ: 'Trenton',
  NM: 'Santa Fe',
  NY: 'Albany',
  NC: 'Raleigh',
  ND: 'Bismarck',
  OH: 'Columbus',
  OK: 'Oklahoma City',
  OR: 'Salem',
  PA: 'Harrisburg',
  RI: 'Providence',
  SC: 'Columbia',
  SD: 'Pierre',
  TN: 'Nashville',
  TX: 'Austin',
  UT: 'Salt Lake City',
  VT: 'Montpelier',
  VA: 'Richmond',
  WA: 'Olympia',
  WV: 'Charleston',
  WI: 'Madison',
  WY: 'Cheyenne',
  DC: 'Washington'
};

const getStateCitiesWithCapitalFirst = (stateCode) => {
  const cities = ALL_US_CITIES_COMPLETE[stateCode];
  if (!Array.isArray(cities)) {
    return [];
  }

  const capital = STATE_CAPITALS[stateCode];
  if (!capital) {
    return [...cities];
  }

  const prioritized = [];
  const seen = new Set();

  const addCity = (cityName) => {
    if (!cityName || typeof cityName !== 'string') {
      return;
    }

    const key = cityName.toLowerCase();
    if (seen.has(key)) {
      return;
    }

    seen.add(key);
    prioritized.push(cityName);
  };

  const matchingCapital = cities.find(
    (city) => city.toLowerCase() === capital.toLowerCase()
  );

  addCity(matchingCapital || capital);
  cities.forEach(addCity);

  return prioritized;
};

/**
 * Flattened array of all US cities for efficient searching
 */
export const ALL_US_CITIES_FLAT = [];

// Build the flattened array
Object.entries(ALL_US_CITIES_COMPLETE).forEach(([state, cities]) => {
  cities.forEach(city => {
    ALL_US_CITIES_FLAT.push({
      city: city,
      state: state,
      name: `${city}, ${state}`,
      country: 'US'
    });
  });
});

/**
 * Search index for fast lookups
 */
export const US_CITY_SEARCH_INDEX = {};

// Build search index
ALL_US_CITIES_FLAT.forEach(cityData => {
  const normalizedCity = cityData.city.toLowerCase();
  if (!US_CITY_SEARCH_INDEX[normalizedCity]) {
    US_CITY_SEARCH_INDEX[normalizedCity] = [];
  }
  US_CITY_SEARCH_INDEX[normalizedCity].push(cityData);
});

/**
 * Enhanced search function for US cities with fuzzy matching and state search
 * @param {string} query - Search query
 * @param {number} limit - Maximum results to return (default: 50)
 * @returns {Array} Array of matching cities with state information
 */
export const searchUSCities = (query, limit = 50) => {
  if (!query || typeof query !== 'string') return [];
  
  const normalizedQuery = query.toLowerCase().trim();
  const results = [];
  
  // Check if query is a state name or abbreviation
  const stateResults = searchByState(normalizedQuery);
  if (stateResults.length > 0) {
    // If searching for a state, return major cities from that state
    results.push(...stateResults.slice(0, Math.min(limit, 20)));
  }
  
  // Exact city name match (highest priority)
  if (US_CITY_SEARCH_INDEX[normalizedQuery]) {
    results.push(...US_CITY_SEARCH_INDEX[normalizedQuery]);
  }
  
  // Starts with query (second priority)
  Object.keys(US_CITY_SEARCH_INDEX).forEach(cityKey => {
    if (cityKey.startsWith(normalizedQuery) && cityKey !== normalizedQuery) {
      results.push(...US_CITY_SEARCH_INDEX[cityKey]);
    }
  });
  
  // Contains query (third priority)
  if (results.length < limit) {
    Object.keys(US_CITY_SEARCH_INDEX).forEach(cityKey => {
      if (cityKey.includes(normalizedQuery) && 
          !cityKey.startsWith(normalizedQuery) && 
          cityKey !== normalizedQuery) {
        results.push(...US_CITY_SEARCH_INDEX[cityKey]);
      }
    });
  }
  
  // Remove duplicates and limit results
  const uniqueResults = results.filter((city, index, self) => 
    index === self.findIndex(c => c.name === city.name)
  );
  
  return uniqueResults.slice(0, limit);
};

/**
 * Search for cities by state name or abbreviation
 * @param {string} stateQuery - State name or abbreviation
 * @returns {Array} Array of cities in the matching state
 */
export const searchByState = (stateQuery) => {
  if (!stateQuery || typeof stateQuery !== 'string') return [];
  
  const normalizedStateQuery = stateQuery.toLowerCase().trim();
  
  // State name to abbreviation mapping
  const stateNames = {
    'alabama': 'AL', 'alaska': 'AK', 'arizona': 'AZ', 'arkansas': 'AR', 'california': 'CA',
    'colorado': 'CO', 'connecticut': 'CT', 'delaware': 'DE', 'florida': 'FL', 'georgia': 'GA',
    'hawaii': 'HI', 'idaho': 'ID', 'illinois': 'IL', 'indiana': 'IN', 'iowa': 'IA',
    'kansas': 'KS', 'kentucky': 'KY', 'louisiana': 'LA', 'maine': 'ME', 'maryland': 'MD',
    'massachusetts': 'MA', 'michigan': 'MI', 'minnesota': 'MN', 'mississippi': 'MS', 'missouri': 'MO',
    'montana': 'MT', 'nebraska': 'NE', 'nevada': 'NV', 'new hampshire': 'NH', 'new jersey': 'NJ',
    'new mexico': 'NM', 'new york': 'NY', 'north carolina': 'NC', 'north dakota': 'ND', 'ohio': 'OH',
    'oklahoma': 'OK', 'oregon': 'OR', 'pennsylvania': 'PA', 'rhode island': 'RI', 'south carolina': 'SC',
    'south dakota': 'SD', 'tennessee': 'TN', 'texas': 'TX', 'utah': 'UT', 'vermont': 'VT',
    'virginia': 'VA', 'washington': 'WA', 'west virginia': 'WV', 'wisconsin': 'WI', 'wyoming': 'WY',
    'district of columbia': 'DC'
  };
  
  // Check if it's a state name
  let stateCode = stateNames[normalizedStateQuery];
  
  // Check if it's already a state abbreviation
  if (!stateCode) {
    const upperQuery = normalizedStateQuery.toUpperCase();
    if (Object.values(stateNames).includes(upperQuery)) {
      stateCode = upperQuery;
    }
  }
  
  if (stateCode && ALL_US_CITIES_COMPLETE[stateCode]) {
    const prioritizedCities = getStateCitiesWithCapitalFirst(stateCode).slice(0, 20);

    return prioritizedCities.map(city => ({
      city: city,
      state: stateCode,
      name: `${city}, ${stateCode}`,
      country: 'US'
    }));
  }
  
  return [];
};

/**
 * Get cities by state
 * @param {string} stateCode - Two-letter state code
 * @returns {Array} Array of cities in the state
 */
export const getCitiesByState = (stateCode) => {
  const state = stateCode?.toUpperCase();
  if (!state || !ALL_US_CITIES_COMPLETE[state]) return [];
  
  return getStateCitiesWithCapitalFirst(state).map(city => ({
    city: city,
    state: state,
    name: `${city}, ${state}`,
    country: 'US'
  }));
};

/**
 * Get random cities for suggestions
 * @param {number} count - Number of random cities to return
 * @returns {Array} Array of random cities
 */
export const getRandomUSCities = (count = 10) => {
  const shuffled = ALL_US_CITIES_FLAT.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

export default ALL_US_CITIES_COMPLETE;
